import React from "react";

import { Widget, WidgetBody, WidgetHeader } from "../../../../components/_widget";
import { LabeledSwitch } from "../../../../components/react/filter/LabeledSwitch";

import { RemediationGuide } from "./RemediationGuide";

export interface MonitorRemediationTabsProps {
	text: string;
	componentIdentifier: string;
	timestamp: number;
	onLinkClick: (autoPinEnabled: boolean) => void;
}

export const MonitorRemediationTabs: React.FC<MonitorRemediationTabsProps> = ({
	text,
	componentIdentifier,
	timestamp,
	onLinkClick,
}) => {
	const [isAutoPinEnabled, setIsAutoPinEnabled] = React.useState(true);

	return (
		<Widget card>
			<WidgetHeader
				help="The suggested troubleshooting steps are based on the best practices relevant for the current health violation."
				size="lg"
				title="Remediation guide"
			>
				<span className="font-normal text-xs leading-[22px]">
					<LabeledSwitch
						checked={isAutoPinEnabled}
						className="ml-2"
						label="Auto pin when following a remediation deep link"
						onChange={setIsAutoPinEnabled}
						size="small"
					/>
				</span>
			</WidgetHeader>

			<WidgetBody>
				<div className="xs:columns-2 gap-10">
					<RemediationGuide
						componentIdentifier={componentIdentifier}
						onInternalLinkClick={() => onLinkClick(isAutoPinEnabled)}
						showPinnedPane={isAutoPinEnabled}
						text={text}
						timestamp={timestamp}
					/>
					<div className="h-10" />
				</div>
			</WidgetBody>
		</Widget>
	);
};
